import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-toolbox';
import moment from 'moment-business-days';
import momentAlt from 'moment';
import { isEmpty } from 'lodash';
import { ResourceCardElement } from 'components/ResourceCardElements';
import DatePicker from 'components/DatePicker';
import TimeInput from 'components/TimeInput';
import ReactSelect from 'components/StyledSelect/react_select';
import Card from 'components/Card';
import ColoredButton from 'components/ColoredButton';
import SimpleInput from 'components/SimpleInput';
import ConfirmDialog from 'components/ConfirmDialog';
import Calendar from '../../../../../schedule/components/calendar';
import AssessmentSuggestions from '../../../../../schedule/components/assessmentSuggestions';
import InstallSuggestions from '../../../../../schedule/components/installSuggestions';
import RescheduleAppointmentModal from './rescheduleAppointmentModal';
import { navigate } from 'actionCreators';
import { addValidationErrors } from 'actionCreators/appointments';
import { requestRelatedPhases } from 'actionCreators/related_phases';
import { urls } from 'helpers/url';
import { Appointment } from 'types/appointment';
import PhaseType from 'types/phase';
import { isDeliveryPhase, normalizeSource } from '../../../../../../../../utils';
import {
  determineProjectedCompletion,
  doTimesOverlap,
  existingApptsRelate,
} from '../../../../../../../../utils/schedulingUtils';
import { getEndTimeString, parseDateStrict } from '../../../../../../../../utils/dateUtils';
import styles from '../styles.scss';
import { FILTER_THEME, REQUIRED_APPT_FIELDS, APPT_TYPES,
         PHASE_APPOINTMENT_TYPES, SCHEDULING_REASONS,
         DEFAULT_ARRIVAL_WINDOW_HOURS, DISPLAY_DATE,
         DISPLAY_DATE_TIME, RAILS_DATE_TIME, AUTO_COMM_MESSAGE,
         RAILS_DATE, MOMENT_TIME, WORK_DAY_HOURS } from 'config/constants';

const APPT_CONFIRMATION_DIFF = 1;
const DEFAULT_STATE = {
  projectedJobDays: 0,
  projectedJobLength: 0,
  projectedCompletion: '',
  note: '',
  confirmationDate: null,
  showRescheduleModal: false,
  showDialog: false,
  showDeliveryDialog: false,
  overrideReschedule: false,
  schedulingReason: '',
  suggestionKey: null,
  assessmentSuggestion: null,
  selectedDeliverySuggestion: null,
  ssBlockage: '',
};
const IS_AFTERNOON = moment().isSameOrAfter(moment().hours(12));

class SchedulePhaseAppointment extends Component {
  constructor(props) {
    super(props);
    this.state = this.getStateObj();
    this.resetState = this.resetState.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDeliverySuggestionSelected = this.handleDeliverySuggestionSelected.bind(this);
    this.handleInstallSuggestionSelected = this.handleInstallSuggestionSelected.bind(this);
    this.handleAssessmentSuggestionSelected = this.handleAssessmentSuggestionSelected.bind(this);
    this.handleSuggestionSelected = this.handleSuggestionSelected.bind(this);
    this.handleSchedulingReasonChange = this.handleSchedulingReasonChange.bind(this);
    this.setDelayedField = this.setDelayedField.bind(this);
    this.clearAssessmentSuggestion = this.clearAssessmentSuggestion.bind(this);
    this.submitAssessmentSuggestionAppt = this.submitAssessmentSuggestionAppt.bind(this);
    this.handleShowAssessmentSuggestions = this.handleShowAssessmentSuggestions.bind(this);
  }

  componentWillMount = () => this.props.requestRelatedPhases(this.props.phase.id);

  getDefaultDate = diff => moment().businessSubtract(diff).format(DISPLAY_DATE);

  getDefaultEndTime = (start, apptType) => this.defaultArrivalWindow(start, apptType);

  getSubtractedDate = (date, diff, businessSub = false) => {
    if (businessSub) return date.clone().businessSubtract(diff, 'days').format(DISPLAY_DATE);
    return date.clone().subtract(diff, 'days').format(DISPLAY_DATE);
  }

  getApptIndex = (apptTypes, phaseType = '') => {
    const isIQM = this.props.role === 'iqm';
    if (!isIQM) return 0;
    const lastIndex = apptTypes.length - 1;
    if (phaseType) return ['Installation', 'Workorder'].includes(phaseType) ? lastIndex : 0;
    return lastIndex;
  }

  getDateFromDifferential = (momentArrivalStart, targetDate) => {
    const newArrivalStartMoment = momentArrivalStart.clone();
    const startMoment = moment(this.state.startDate, DISPLAY_DATE);
    const endMoment = moment(targetDate, DISPLAY_DATE);
    let endDate = targetDate;
    if (startMoment.isValid() && endMoment.isValid()) {
      endDate = newArrivalStartMoment.add(endMoment.diff(startMoment, 'days'), 'days').format(DISPLAY_DATE);
    }
    return endDate;
  }

  getEarlierBusinessDate = (date, diff) => date.clone().businessSubtract(diff).format(DISPLAY_DATE);

  getSaveableDate = date => date && moment(date, DISPLAY_DATE).format(RAILS_DATE);

  getDefaultCalStart = (suggestion, needDelivery = false) => {
    const { phase: { vendor_eta, surface_type: { id } } } = this.props;
    if (suggestion) {
      if (vendor_eta) return moment(vendor_eta).add(3, 'days');
      if (needDelivery || id === 2) return moment().add(2, 'days');
      if (id !== 2) return moment().add(4, 'days');
    }
    return moment().add(this.isAssessment() && IS_AFTERNOON ? 2 : 1, 'days');
  }

  getStateObj = (overrideToCal = false) => {
    const { appointment, isEdit, originalStart, originalEnd, phase: {
            estimator, zip_code, estimator_id, installer_id, surface_type, store, type,
            spig_delivery, surface_type: { id, name }, store: { workroom_id, delivery_method },
            workroom: { timezone } }, role } = this.props;
    const query = window.location.href;
    const apptType = (this.props.quickSchedule && this.props.quickSchedule.forceKind) ||
      window.location.href.split(query.includes('new/') ? 'new/' : 'edit/')[1] || '';
    const arrivalTimes = isEdit ?
      { arrivalStart: originalStart, arrivalEnd: originalEnd } :
      { arrivalStart: '08:00', arrivalEnd: this.getDefaultEndTime('08:00', apptType) };
    const selectedAssignee = this.isAssessment(apptType) && estimator ? { ...estimator, kind: 'Estimator' } : null;
    const smartSchedulable = this.isInstallApptType(apptType);
    const showInstallSuggestions = this.isCcs() && smartSchedulable
      && !overrideToCal && !this.isIfi();
    const needDelivery = isDeliveryPhase(type, name, delivery_method, spig_delivery);
    const defaultCalStart = this.getDefaultCalStart(showInstallSuggestions, needDelivery);
    const scheduleStart = appointment ?
      moment(appointment.startDate, DISPLAY_DATE).toDate() : defaultCalStart.toDate();
    const defaultDates = {};
    if (this.hasConfirmationAndPickup(apptType)) {
      const apptConfDate = this.getSubtractedDate(defaultCalStart, APPT_CONFIRMATION_DIFF, true);
      const pickupDiff = name.toLowerCase() === 'carpet' || name === 'Backsplash' ? 0 : 3;
      defaultDates.confirmationDate = apptConfDate;
      defaultDates.pickupDate = this.getDefaultDate(pickupDiff);
    }
    const apptDate = defaultCalStart.format(DISPLAY_DATE).toString();
    const zone = timezone.includes('Central') ? 'CST' : 'EST';
    return {
      zone,
      ...DEFAULT_STATE,
      startDate: apptDate,
      endDate: apptDate,
      defaultCalStart,
      apptType,
      showInstallSuggestions,
      ...arrivalTimes,
      selectedAssignee,
      workroom: store ? [workroom_id] : [],
      assignee_type: this.contractorType(apptType),
      surface_type: surface_type ? [id] : [],
      estimator: { zip_code, estimator_id, ...(this.isIfi() ? { ifi: true } : {}) },
      crew: { zip_code, ...(this.isIfi() ? { installer_id, ifi: true } : {}) },
      scheduleStart,
      ...defaultDates,
      ...(appointment || {}),
      smartSchedulable,
      needDelivery,
      applyDeliveryValidation: needDelivery,
      showAssessmentSuggestions: this.isAssessment() && role !== 'estimator' && !this.isIfi(),
    };
  }

  setDelayedField = (field, val) => this.setState({ [field]: val });
  normalizeProjectedCompletion = value => (
    this.isProjectedCompletionEmpty(value) ? null : value
  );

  resetState = overrideToCal => this.setState(this.getStateObj(overrideToCal));

  clearAssessmentSuggestion = () =>
    this.setState({ suggestionKey: null, assessmentSuggestion: null });

  isInstallApptType = (apptType = '') => ['installation', 'installation_hold'].includes(apptType || (this.state && this.state.apptType) || '');

  isAssessment = (type = (this.props.phase && this.props.phase.type) || '') => type.toLowerCase() === 'assessment';

  isCcs = () => this.props.position === 'Customer Care Specialist';

  isEmployee = () => this.props.employableType === 'Employee';

  isIfi = () => this.props.phase && this.props.phase.source === 'IFI';

  assigneeSmartSchedulable = () => (this.state.selectedAssignee &&
    (this.state.selectedAssignee.kind || '') === 'Crew' &&
    !this.state.selectedAssignee.specificMismatch);

  isDeliveryAppt = (apptType = '') => ['delivery', 'deliver_stack_cali_bamboo', 'delivery_hold'].includes(apptType || this.state.apptType);

  handleDeliveryValidation = () =>
    this.setState({ applyDeliveryValidation: !this.state.applyDeliveryValidation })

  handleShowAssessmentSuggestions = (bool = true) =>
    this.setState({ showAssessmentSuggestions: bool });

  toggleFilterDrawer = () => this.setState({ showFilterDrawer: !this.state.showFilterDrawer })

  defaultArrivalWindow = (startTime, apptType) => {
    const start = moment(startTime, 'HH:mm');
    if (!start.isValid()) return startTime;
    return start.add(DEFAULT_ARRIVAL_WINDOW_HOURS[apptType] || DEFAULT_ARRIVAL_WINDOW_HOURS.default, 'h').format('HH:mm');
  }

  deselectAssignee = () => this.setState({ selectedAssignee: null });

  apptTypeOptions = () => {
    const { phase, role } = this.props;
    if (role === 'iqm') return [APPT_TYPES[APPT_TYPES.length - 1]];
    const values = PHASE_APPOINTMENT_TYPES[phase.type];
    if (!values) return APPT_TYPES;
    return APPT_TYPES.filter(o => this.apptTypeOptionsFilter(o, values));
  };

  apptTypeOptionsFilter = (apptType, values) => {
    const { applyDeliveryValidation } = this.state;
    const { phase: { store, surface_information: { wood_flooring_type } } } = this.props;
    const { value } = apptType;
    // Remove 'Delivery' and 'Deliver/Stack Cali Bamboo' option from appts drop down if
    // store doesn't deliver
    if (this.isDeliveryAppt(value) && store.delivery_method === 'None') return false;
    // Don't show 'Deliver/Stack Cali Bamboo' as an option if Phase surface type isn't Cali Bamboo
    // or Delivery Validation is off
    if (value === 'deliver_stack_cali_bamboo' &&
       (wood_flooring_type !== 'Cali Bamboo' || !applyDeliveryValidation)) return false;
    // Show 'Delivery/Stack Cali Bamboo' and remove 'Delivery' and 'Stack Cali Bamboo'
    // if Delivery Validation is on and phase surface type is Cali Bamboo
    if (applyDeliveryValidation &&
        wood_flooring_type === 'Cali Bamboo' &&
        this.isDeliveryAppt(value)) return false;
    return values.includes(value);
  }

  handleAppointmentTypeChange = (apptType, overrideReschedule) => this.setState({
    apptType,
    assignee_type: this.contractorType(apptType),
    arrivalEnd: this.defaultArrivalWindow(this.state.arrivalStart, apptType),
    overrideReschedule,
    smartSchedulable: this.isInstallApptType(apptType),
  });

  handleArrivalStartChange = (time, clearAssignee = false) => {
    const { smartSchedulable, arrivalStart, arrivalEnd } = this.state;
    const applySsFeatures = smartSchedulable && this.assigneeSmartSchedulable();
    const arrivalStartMoment = moment(arrivalStart, 'HH:mm');
    const newArrivalStartMoment = moment(time, 'HH:mm');
    const arrivalEndMoment = moment(arrivalEnd, 'HH:mm');
    let newArrivalEnd = arrivalEnd;
    if (arrivalStartMoment.isValid() &&
        newArrivalStartMoment.isValid() &&
        arrivalEndMoment.isValid()) {
      newArrivalEnd = newArrivalStartMoment.add(arrivalEndMoment.diff(arrivalStartMoment, 'seconds'), 'seconds').format('HH:mm');
    }
    const newState = { arrivalStart: time, arrivalEnd: newArrivalEnd };
    if (applySsFeatures && clearAssignee) {
      newState.selectedAssignee = null;
      this.setState(newState);
    } else this.setState(newState, () => this.handleProjectedCompletionChange());
  }

  handleArrivalEndChange = (time, clearAssignee = false) => {
    const applySsFeatures = this.state.smartSchedulable && this.assigneeSmartSchedulable();
    const newState = { arrivalEnd: time };
    if (applySsFeatures && clearAssignee) newState.selectedAssignee = null;
    this.setState(newState);
  }

  handleNoteChange = event => this.setState({ note: event.target.value });

  handleConfirmationDateChange = kind => date => this.setState({ [kind]: date });

  hasConfirmationAndPickup = (kind = this.state.apptType) => ['installation', 'installation_hold', 'repair'].includes(kind);

  handlePickupDateChange = date => this.setState({ pickupDate: date });

  handleProjectedCompletionChange = (isSuggestion = false) => {
    const { smartSchedulable, projectedJobLength, projectedJobDays,
      startDate, arrivalStart, selectedAssignee } = this.state;
    if (isSuggestion || (smartSchedulable && this.assigneeSmartSchedulable())) {
      const projectedCompletion = moment(
        determineProjectedCompletion(
          projectedJobLength,
          projectedJobDays,
          startDate,
          arrivalStart,
          selectedAssignee.suggestedStartTime || '',
        ),
        DISPLAY_DATE_TIME,
        true,
      ).format(RAILS_DATE_TIME);
      this.setState({ projectedCompletion });
    }
  }

  handleSuggestionDates = (date) => {
    const { phase: { surface_type: { name } } } = this.props;
    const { projectedJobDays } = this.state;
    const startMoment = parseDateStrict(date, DISPLAY_DATE);
    const startDate = startMoment.clone().format(DISPLAY_DATE);
    const apptConfDate = this.getSubtractedDate(startMoment, APPT_CONFIRMATION_DIFF, true);
    this.setState({
      startDate,
      endDate: startMoment.clone().add(projectedJobDays - 1, 'days').format(DISPLAY_DATE),
      confirmationDate: apptConfDate,
      pickupDate: this.getEarlierBusinessDate(startMoment, ['Carpet', 'Backsplash'].includes(name) ? 0 : 3),
      scheduleStart: moment(startDate, DISPLAY_DATE, true).toDate(),
    });
  }

  handleStartDateChange = (date, clearAssignee = false) => {
    const { phase: { surface_type } } = this.props;
    const { smartSchedulable, selectedAssignee = {},
            projectedJobDays, endDate } = this.state;
    const ssAssignee = this.assigneeSmartSchedulable();
    const applySsFeatures = smartSchedulable && ssAssignee;
    const newArrivalStartMoment = moment.isMoment(date) ? date : moment(date, DISPLAY_DATE, true);
    if (newArrivalStartMoment.isValid()) {
      const newState = {
        startDate: newArrivalStartMoment.format(DISPLAY_DATE),
        endDate: applySsFeatures ?
          newArrivalStartMoment.clone().add(Math.max(projectedJobDays, 1) - 1, 'days').format(DISPLAY_DATE) :
          this.getDateFromDifferential(newArrivalStartMoment, endDate),
      };
      if (this.hasConfirmationAndPickup()) {
        const startMoment = moment(newState.startDate, DISPLAY_DATE, true);
        const pickupDiff = surface_type.name.toLowerCase() === 'carpet' ||
          surface_type.name === 'Backsplash' ? 0 : 3;
        newState.confirmationDate =
          this.getSubtractedDate(startMoment, APPT_CONFIRMATION_DIFF, true);
        newState.pickupDate = this.getSubtractedDate(startMoment, pickupDiff, true);
      }
      if (clearAssignee && applySsFeatures) {
        newState.selectedAssignee = null;
        this.setState(newState);
      } else if (applySsFeatures) {
        newState.scheduleStart = moment(newState.startDate, DISPLAY_DATE, true).toDate();
        this.setState(newState, () =>
          this.handleArrivalStartChange(selectedAssignee.suggestedStartTime || '08:00', false));
      } else this.setState(newState);
    }
  }

  handleEndDateChange = (date, clearAssignee = false) => {
    const applySsFeatures = this.state.smartSchedulable && this.assigneeSmartSchedulable();
    if (moment(date, DISPLAY_DATE, true).isValid()) {
      const newState = { endDate: date };
      if (applySsFeatures && clearAssignee) newState.selectedAssignee = null;
      this.setState(newState);
    }
  }

  handleSchedulingReasonChange = option => this.setState({ schedulingReason: option.value });

  handleDeliverySuggestionSelected = (suggestionData) => {
    const { key, assignee, opening, startTime, endTime } = suggestionData;
    this.setState({
      selectedDeliverySuggestion: key,
      selectedDeliveryAssignee: { ...assignee, suggestedStartTime: startTime },
      deliveryStartDate: opening,
      deliveryArrivalStart: startTime,
      deliveryArrivalEnd: endTime,
      suggestionKey: null,
      selectedAssignee: null,
      arrivalStart: null,
      arrivalEnd: null,
      projectedJobDays: null,
      projectedJobLength: null,
      projectedCompletion: null,
      startDate: null,
      endDate: null,
      confirmationDate: null,
      pickupDate: null,
    });
  }

  handleInstallSuggestionSelected = (suggestionData) => {
    const { key, assignee, opening, projectedJobDays, projectedJobLength,
            projectedCompletion, startTime, endTime } = suggestionData;
    let normalizedCompletion = projectedCompletion;
    if (projectedCompletion) {
      const completionMoment = parseDateStrict(projectedCompletion, DISPLAY_DATE_TIME);
      if (completionMoment.isValid()) {
        normalizedCompletion = completionMoment.format(RAILS_DATE_TIME);
      }
    }
    this.setState({
      suggestionKey: key,
      selectedAssignee: { ...assignee, suggestedStartTime: startTime },
      arrivalStart: startTime,
      arrivalEnd: endTime,
      projectedJobDays,
      projectedJobLength,
      projectedCompletion: normalizedCompletion,
    }, () => this.handleSuggestionDates(opening));
  }

  handleAssessmentSuggestionSelected = (suggestionData) => {
    const { key } = suggestionData;
    this.setState({
      suggestionKey: key,
      assessmentSuggestion: suggestionData,
    });
  }

  handleSuggestionSelected = (suggestionData, type = 'install') => {
    switch (type) {
      case 'assessment':
        this.handleAssessmentSuggestionSelected(suggestionData);
        break;
      case 'delivery':
        this.handleDeliverySuggestionSelected(suggestionData);
        break;
      default:
        this.handleInstallSuggestionSelected(suggestionData);
    }
  }

  handleScheduleSelect = (date, {
    appointments, assignee, projectedJobDays = 0, projectedJobLength = 0,
  }, adjustedStartTime, ssBlockage) => this.setState({
    selectedAssignee: {
      ...assignee,
      appointments,
      suggestedStartTime: adjustedStartTime || assignee.default_start_time || '',
    },
    ssBlockage,
    projectedJobDays: projectedJobDays || 0,
    projectedJobLength: projectedJobLength || 0,
  }, () => this.handleStartDateChange(date, false));

  handleOpeningClick = (nextOpening, member) => this.handleScheduleSelect(
    nextOpening, member, (member.assignee.crew_specific || {}).default_start_time || '',
  );

  handleRescheduleClose = () => this.setState({ showRescheduleModal: false });

  handleSubmit = (newApptType = '') => {
    if (!this.validate()) return;
    if (this.props.quickSchedule) {
      this.submitQuickSchedule(newApptType);
      return;
    }
    if (this.isReschedule()) this.setState({ showRescheduleModal: true });
    else if (this.state.showInstallSuggestions) this.submitInstallSuggestionAppt({}, newApptType);
    else this.submitAppointment({}, newApptType);
  }

  submitQuickSchedule = (newApptType = '') => {
    const {
      apptType, selectedAssignee, startDate, endDate, arrivalStart, arrivalEnd,
      confirmationDate, note, pickupDate, schedulingReason,
    } = this.state;
    const effectiveKind = newApptType || apptType;
    const params = {
      ...this.buildBaseParams({
        kind: effectiveKind,
        startDate,
        endDate,
        arrivalStart,
        arrivalEnd,
        confirmationDate,
        note: note || '',
        pickupDate,
        schedulingReason,
      }),
      assignee_id: (selectedAssignee && selectedAssignee.id) || null,
      assignee_type: (selectedAssignee && selectedAssignee.kind) || null,
    };
    return this.props.quickSchedule.onSubmit(this.props.phase.id, params);
  }

  handleCancel = () => this.props.navigate(urls.phaseAppointments(this.props.phase));

  handleFilterChange = (key, value) => this.setState({ [key]: value });

  isReschedule = () => {
    const { arrivalStart, arrivalEnd, startDate, endDate, selectedAssignee,
            overrideReschedule, apptType, showInstallSuggestions } = this.state;
    const { appointment, isEdit } = this.props;
    if (showInstallSuggestions) return isEdit;
    if (!(appointment && appointment.id) || overrideReschedule) return false;
    return (appointment.apptType !== apptType ||
            appointment.arrivalStart !== arrivalStart ||
            appointment.arrivalEnd !== arrivalEnd ||
            appointment.startDate !== startDate ||
            appointment.endDate !== endDate ||
            appointment.selectedAssignee.id !== selectedAssignee.id ||
            appointment.selectedAssignee.kind !== selectedAssignee.kind);
  }

  warningArray = () => {
    const { ssBlockage } = this.state;
    if (!ssBlockage) return [];
    const strippedBlockage = ssBlockage.replace('WARNING: ', '');
    if (!strippedBlockage.includes(',')) return [strippedBlockage];
    return strippedBlockage.split(', ');
  }

  submitSuggestionInstall = (phaseId, params, submitArgs, event, phase) =>
    this.props.onSubmit(phaseId, params, submitArgs, event || {})
      .then((data) => {
        if (data.payload.inspection_required && !this.isIfi()) this.toggleConfirmDialog();
        else this.props.navigate(urls.phaseAppointments(phase));
      })
      .catch(() => { });

  submitAssessmentSuggestionAppt = () => {
    const { phase: { id: phaseId }, userName, isEdit } = this.props;
    const { assessmentSuggestion: { kind, start_date, end_date, arrival_start_time,
                                    arrival_end_time, assignee_id, assignee_type } } = this.state;
    const params = {
      kind,
      start_date: this.getSaveableDate(start_date),
      end_date: this.getSaveableDate(end_date),
      arrival_start_time,
      arrival_end_time,
      appointment_confirmation_date: null,
      note: isEdit ? `Assessment edited via Smart Scheduling by ${userName}` :
        `Smart Scheduling-generated assessment saved by ${userName}`,
      scheduling_reason: '',
      assignee_id,
      assignee_type,
    };
    const submitArgs = { source: 'suggestion', ignoredWarnings: [] };
    return this.props.onSubmit(phaseId, params, submitArgs, {})
      .then(() => {
        this.props.navigate(urls.phaseAppointments(this.props.phase));
      })
      .catch(() => {});
  };

  // Helper: determines whether a projected completion value is effectively empty
  isProjectedCompletionEmpty = value => (!value || (typeof value === 'string' && value.trim() === ''));

  // Builds common appointment params (formats dates once, ensures consistent keys)
  buildBaseParams = ({
    kind,
    startDate,
    endDate,
    arrivalStart,
    arrivalEnd,
    confirmationDate,
    note,
    pickupDate,
    schedulingReason,
  }) => ({
    kind,
    start_date: this.getSaveableDate(startDate),
    end_date: this.getSaveableDate(endDate),
    arrival_start_time: arrivalStart,
    arrival_end_time: arrivalEnd,
    appointment_confirmation_date: this.getSaveableDate(confirmationDate),
    note,
    pickup_date: this.getSaveableDate(pickupDate),
    scheduling_reason: schedulingReason,
  });

  computeProjCompletion = ({
    startDate,
    arrivalStart,
    projectedJobLength,
    projectedJobDays,
    selectedAssignee,
  }) => {
    const suggested =
      (selectedAssignee && (selectedAssignee.suggestedStartTime || selectedAssignee.default_start_time)) || '';
    if (projectedJobLength > 0 && projectedJobDays > 0) {
      const value = determineProjectedCompletion(
        projectedJobLength,
        projectedJobDays,
        startDate,
        arrivalStart,
        suggested,
      );
      if (value && moment(value, DISPLAY_DATE_TIME, true).isValid()) {
        return moment(value, DISPLAY_DATE_TIME, true).format(RAILS_DATE_TIME);
      }
      return '';
    }
    // Fallback: end of the arrival window on the start day using default window size
    const startT = arrivalStart || '08:00';
    const endT = getEndTimeString(startT, false);
    if (startDate) {
      const fallbackMoment = parseDateStrict(
        `${startDate} ${endT}`,
        `${DISPLAY_DATE} ${MOMENT_TIME}`,
      );
      if (fallbackMoment.isValid()) {
        return fallbackMoment.format(RAILS_DATE_TIME);
      }
    }
    return '';
  };

  submitInstallSuggestionAppt = (event, newApptType = '') => {
    const { phase, phase: { id: phaseId }, userName } = this.props;
    const { apptType, startDate, endDate, arrivalStart, arrivalEnd, confirmationDate, pickupDate,
            schedulingReason, projectedCompletion, projectedJobLength,
            selectedAssignee: { id: installerId, kind }, selectedDeliveryAssignee = null,
            deliveryStartDate = null, deliveryArrivalStart = null, deliveryArrivalEnd = null,
            needDelivery = false } = this.state;
    const apptKind = newApptType || apptType;

    let projCompletion = projectedCompletion;
    if (this.isProjectedCompletionEmpty(projCompletion) &&
        this.isInstallApptType(apptKind) &&
        startDate && arrivalStart) {
      // Use days inferred from length when suggestions are active.
      const inferredDays = Math.max(1, Math.ceil(projectedJobLength / WORK_DAY_HOURS));
      projCompletion = this.computeProjCompletion({
        startDate,
        arrivalStart,
        projectedJobLength,
        projectedJobDays: inferredDays,
        selectedAssignee: this.state.selectedAssignee,
      });
    }
    const params = {
      ...this.buildBaseParams({
        kind: apptKind,
        startDate,
        endDate,
        arrivalStart,
        arrivalEnd,
        confirmationDate,
        note: `Smart Scheduling-generated appt. ${newApptType ? 'edited' : 'saved'} by ${userName}`,
        pickupDate: needDelivery ? deliveryStartDate : pickupDate,
        schedulingReason,
      }),
      projected_completion: this.normalizeProjectedCompletion(projCompletion),
      projected_job_length: projectedJobLength,
      assignee_id: installerId,
      assignee_type: kind,
    };
    const submitArgs = { source: 'suggestion', ignoredWarnings: [] };
    if (needDelivery) {
      const apptDate = this.getSaveableDate(deliveryStartDate);
      const deliveryKind = `delivery${apptKind.includes('hold') ? '_hold' : ''}`;
      const deliveryParams = {
        kind: deliveryKind,
        start_date: apptDate,
        end_date: apptDate,
        arrival_start_time: deliveryArrivalStart,
        arrival_end_time: deliveryArrivalEnd,
        note: `Smart Scheduling-generated delivery ${deliveryKind.includes('hold') ?
          'hold' : ''} saved by ${userName}`,
        scheduling_reason: schedulingReason,
        assignee_id: selectedDeliveryAssignee.id || null,
        assignee_type: selectedDeliveryAssignee.kind || null,
      };
      return this.props.onSubmit(phaseId, deliveryParams, submitArgs, {})
        .then(() => this.submitSuggestionInstall(phaseId, params, submitArgs, event || {}, phase));
    }
    return this.submitSuggestionInstall(phaseId, params, submitArgs, event || {}, phase);
  }

  submitAppointment = (event, newApptType = '') => {
    const {
      apptType, selectedAssignee, startDate, endDate, arrivalStart, arrivalEnd, confirmationDate,
      note, pickupDate, showRescheduleModal, overrideReschedule, schedulingReason,
      projectedCompletion, projectedJobLength = 0, projectedJobDays = 0,
    } = this.state;
    const effectiveKind = newApptType || apptType;

    let projCompletion = projectedCompletion;
    if (this.isProjectedCompletionEmpty(projCompletion) &&
        this.isInstallApptType(effectiveKind) &&
        startDate && arrivalStart) {
      projCompletion = this.computeProjCompletion({
        startDate,
        arrivalStart,
        projectedJobLength,
        projectedJobDays,
        selectedAssignee,
      });
    }
    const params = {
      ...this.buildBaseParams({
        kind: effectiveKind,
        startDate,
        endDate,
        arrivalStart,
        arrivalEnd,
        confirmationDate,
        note: note || '',
        pickupDate,
        schedulingReason,
      }),
      projected_completion: this.normalizeProjectedCompletion(projCompletion),
    };
    if (selectedAssignee && selectedAssignee.id) {
      params.assignee_id = selectedAssignee.id;
      params.assignee_type = selectedAssignee.kind;
    } else {
      params.assignee_id = null;
      params.assignee_type = null;
    }
    const phase = this.props.phase;
    const ignoredWarnings = this.warningArray();
    if (this.props.isEdit && overrideReschedule) {
      return this.props.onSubmit(phase.id, params, { source: 'calendar', ignoredWarnings }, event, overrideReschedule)
        .then((data) => {
          if (data.payload.inspection_required) this.handleCrewInspection(true);
          else this.props.navigate(urls.phaseAppointments(phase));
        })
        .catch(() => { });
    }
    return this.props.onSubmit(phase.id, params, { source: 'calendar', ignoredWarnings }, event)
      .then((data) => {
        const { payload: { appointment: { kind } } } = data;
        if (showRescheduleModal) this.handleRescheduleClose();
        if (data.payload.inspection_required) this.handleCrewInspection(showRescheduleModal);
        else if (this.isDeliveryAppt(kind)) {
          this.toggleConfirmDeliveryDialog();
        } else this.props.navigate(urls.phaseAppointments(phase));
      })
      .catch(() => { });
  }

  handleCrewInspection = (overrideReschedule) => {
    if (this.isIfi()) {
      this.props.navigate(urls.phaseAppointments(this.props.phase));
    } else {
      this.handleAppointmentTypeChange('crew_inspection', overrideReschedule);
      this.toggleConfirmDialog();
    }
  }

  toggleConfirmDialog = () => this.setState({ showDialog: !this.state.showDialog });

  toggleConfirmDeliveryDialog = () =>
   this.setState({ showDeliveryDialog: !this.state.showDeliveryDialog });

  handleDeliveryApptSuccess = (apptType) => {
    const { startDate } = this.state;
    const deliveryApptDay = moment(startDate);
    const deliveryApptDayClone = deliveryApptDay.clone();
    if (['delivery', 'delivery_hold'].includes(apptType)) {
      const threeDaysLater = deliveryApptDayClone.add(3, 'days');
      this.handleStartDateChange(threeDaysLater);
    } else if (apptType === 'deliver_stack_cali_bamboo') {
      const sevenDaysLater = deliveryApptDayClone.add(7, 'days');
      this.handleStartDateChange(sevenDaysLater, false);
    }
    this.handleAppointmentTypeChange(apptType === 'delivery_hold' ? 'installation_hold' : 'installation', true);
    this.toggleConfirmDeliveryDialog();
  }

  validate = () => {
    const { arrivalStart, arrivalEnd, startDate, endDate,
      confirmationDate, pickupDate } = this.state;
    const errors = this.state.errors || {};
    if (Object.keys(errors).length === 0) {
      const as = moment.duration(arrivalStart).asSeconds();
      const ae = moment.duration(arrivalEnd).asSeconds();
      if (as > ae) errors.arrivalStart = ['Must be earlier than end time'];
    }
    const startMoment = moment(startDate, DISPLAY_DATE);
    errors.startDate = this.validateDate(startDate, null, null, true);
    errors.endDate = this.validateDate(endDate, startMoment, 'gte', true);
    errors.confirmationDate = this.validateDate(confirmationDate, startMoment, 'lt');
    errors.pickupDate = this.validateDate(pickupDate, startMoment, 'lte');
    const hasErrors = Object.values(errors).some(error => error);
    if (hasErrors) this.props.addValidationErrors(errors);
    return !hasErrors;
  }

  validateDate = (date, comparisonDate, comparison, required = false) => {
    const invalidDate = ['Please enter a valid date'];
    if (!date || date.toString().trim() === '') return required ? invalidDate : null;
    const momentDate = moment(date, DISPLAY_DATE);
    if (!momentDate.isValid()) return invalidDate;
    if (comparison === 'lt' && momentDate.isSameOrAfter(comparisonDate, 'day')) {
      return ['Date must be before appointment date.'];
    }
    if (comparison === 'lte' && momentDate.isAfter(comparisonDate, 'day')) {
      return ['Date cannot be after appointment date.'];
    }
    if (comparison === 'gte' && momentDate.isBefore(comparisonDate, 'day')) {
      return ['Date cannot be before appointment date.'];
    }
    return null;
  }

  nextSchedule = numDays => () => this.setState({
    scheduleStart: moment(this.state.scheduleStart).add(numDays, 'days').toDate(),
  });

  lastSchedule = numDays => () => this.setState({
    scheduleStart: moment(this.state.scheduleStart).subtract(numDays, 'days').toDate(),
  });

  handleJumpDate = date => this.setState({ scheduleStart: date.toDate() });

  pendingAppointment = () => {
    const { phase, appointment } = this.props;
    const { apptType, arrivalStart, arrivalEnd, startDate,
            endDate, projectedCompletion } = this.state;
    return ({
      id: (appointment && appointment.id) || -1,
      start_date: moment(startDate, DISPLAY_DATE, true).format(RAILS_DATE),
      end_date: moment(endDate, DISPLAY_DATE, true).format(RAILS_DATE),
      arrival_start_time: arrivalStart,
      arrival_end_time: arrivalEnd,
      projected_completion: projectedCompletion,
      kind: apptType,
      phase,
      selected: true,
    });
  }

  contractorType = (apptType) => {
    switch (apptType) {
      case 'assessment':
      case 'assessment_hold':
        return this.isIfi() ? ['Estimator', 'Crew'] : ['Estimator', 'Employee'];
      case 'installation':
      case 'installation_hold':
      case 'bust_day':
        return ['Crew'];
      case 'delivery':
      case 'delivery_hold':
      case 'deliver_stack_cali_bamboo':
        return ['Crew', 'Employee', 'IQM'];
      case 'stack_cali_bamboo':
      case 'repair':
      case 'repair_inspection':
        return ['Crew', 'IQM', 'Employee'];
      case 'crew_inspection':
      case 'jobsite_inspection':
        return ['IQM', 'Employee'];
      default:
        return [];
    }
  }

  schedInstallAfterDeliveryWarning = (appointments) => {
    const { startDate } = this.state;
    const chosenDate = moment(startDate);
    const chosenDateClone1 = chosenDate.clone();
    const chosenDateClone2 = chosenDate.clone();
    const threeDaysBefore = chosenDateClone1.subtract(3, 'days');
    const sevenDaysBefore = chosenDateClone2.subtract(7, 'days');
    let warning = '';
    appointments.forEach((appt) => {
      const deliveryAppt = moment(appt.start_date);
      // Test having both a delivery and delivery_stack_cali bamboo case
      if (appt.kind === 'delivery' &&
          (deliveryAppt.isBetween(threeDaysBefore, chosenDate) ||
           deliveryAppt.isSame(chosenDate) ||
           chosenDate.isBefore(deliveryAppt))) {
        warning = `Installation appointment must be at least 3 days after Delivery
                   appointment on ${moment(deliveryAppt).format('MM/DD/YYYY')}`;
      } else if (appt.kind === 'deliver_stack_cali_bamboo' &&
          (deliveryAppt.isBetween(sevenDaysBefore, chosenDate) ||
           deliveryAppt.isSame(chosenDate) ||
           chosenDate.isBefore(deliveryAppt))) {
        warning = `Installation appointment must be at least 7 days after Cali Bamboo Delivery
                   appointment on ${moment(deliveryAppt).format(DISPLAY_DATE)}`;
      }
    });
    return warning;
  }

  findSuggestionDisableReason = (phase, selectedAssignee = null) => {
    if (!selectedAssignee) return '';
    const { zip_code, workroom: { id: phaseWorkroom } } = phase;
    const { kind = '', covered_zip_codes = [], traveling_zip_codes = [], workrooms: assigneeWorkrooms = [] } = selectedAssignee;
    if (kind !== 'Crew') return 'Selected assignee is not a crew';
    if (!assigneeWorkrooms.length || !assigneeWorkrooms.some(w => w.workroom.id === phaseWorkroom)) return 'Selected assignee is not assigned to phase workroom';
    if ((!covered_zip_codes.length || !covered_zip_codes.includes(zip_code)) &&
        (!traveling_zip_codes.length || !traveling_zip_codes.includes(zip_code))) return 'Selected assignee is not assigned to phase zip code';
    return '';
  }

  blockedByUserVendorPerms = () => {
    const { mvw = null, phase: { source = '' } } = this.props;
    if (!this.isEmployee()) return false;
    const vendorToCheck = normalizeSource(source).toLowerCase();
    return mvw && mvw[vendorToCheck] === false;
  }

  blockedByVendor = () => {
    const { phase: { source }, mvw = null } = this.props;
    const { selectedAssignee = null, startDate, endDate } = this.state;
    const normalizedSource = normalizeSource(source);
    if (this.blockedByUserVendorPerms()) return 'User lacks scheduling permissions for phase vendor';
    if (!selectedAssignee || !(selectedAssignee.appointments || []).length) return false;
    const selectedMemberSameDayAppts = selectedAssignee.appointments.filter((a) => {
      const { start_date, end_date } = a;
      const apptRange = momentAlt.range(momentAlt(start_date, RAILS_DATE),
                        momentAlt(end_date, RAILS_DATE));
      return apptRange.contains(momentAlt(startDate, DISPLAY_DATE)) ||
              apptRange.contains(momentAlt(endDate, DISPLAY_DATE));
    });
    if (selectedMemberSameDayAppts.length === 0) return false;
    return this.isEmployee() && selectedMemberSameDayAppts.some((a) => {
      const { phase: { source: apptSource } } = a;
      const vendorToMatch = normalizeSource(apptSource);
      return !(mvw[vendorToMatch.toLowerCase()] || false) ||
      (!this.isAssessment() && vendorToMatch !== normalizedSource);
    });
  }

  renderDeliveryValidationWarning = () => {
    const { applyDeliveryValidation, apptType } = this.state;
    const { phase: { appointments } } = this.props;
    let warning = '';
    if (applyDeliveryValidation && apptType === 'installation') {
      const deliveryScheduled = appointments.some(appt => this.isDeliveryAppt(appt.kind));
      // if a delivery has not been scheduled, render warning and don't allow save
      if (deliveryScheduled === false) return 'Must schedule Delivery before Installation';
      // Before installation appointment make sure delivery appt is at least
      // 3 days prior while cali bamboo delivery is at least 7 days prior
      warning = this.schedInstallAfterDeliveryWarning(appointments);
    }
    return warning;
  }

  renderWarning = () => {
    let warning = this.renderFieldsWarning();
    if (!this.isIfi() && !warning &&
        this.state.apptType === 'installation' &&
        this.state.applyDeliveryValidation) warning = this.renderDeliveryValidationWarning();
    return warning;
  }

  renderFieldsWarning = () => {
    const { startDate, arrivalStart, smartSchedulable,
            selectedAssignee: assignee = {} } = this.state;
    const applySsFeatures = smartSchedulable && this.assigneeSmartSchedulable();
    const { originalDate, originalStart, phase: {
      id, communication_method, type }, relatedPhases } = this.props;
    const apptMoment = moment(`${originalDate} ${originalStart}`, `${DISPLAY_DATE} HH:mm`, true);
    const nowMoment = moment();
    const dateTimeChanged = (originalDate || originalStart) &&
      (originalDate !== startDate || originalStart !== arrivalStart);
    const apptInPast = (moment(apptMoment).isBefore(nowMoment));
    const autoComm = communication_method && communication_method.toLowerCase() !== 'none';
    const canBeSSBlocked = !this.isIfi() &&
                           applySsFeatures &&
                           !isEmpty(assignee) &&
                           (assignee.apptsOnDay || []).length &&
                           !existingApptsRelate(id, assignee.apptsOnDay || [], relatedPhases);
    let warning = '';
    const vendorBlocked = this.blockedByVendor();
    if (typeof vendorBlocked === 'string') warning = vendorBlocked;
    else if (vendorBlocked) {
      warning = 'Assignee has appts. scheduled outside of your service area';
    } else if (canBeSSBlocked && doTimesOverlap(
      this.pendingAppointment(), assignee.apptsOnDay[0],
    )) {
      warning = 'Times overlap, please change the start time';
    } else {
      const requiredFields = Object.keys(REQUIRED_APPT_FIELDS);
      requiredFields.forEach((field) => {
        if (!((['Assessment', 'Workorder'].includes(type)
          || this.state.apptType.includes('inspection')) && field === 'schedulingReason'
        ) && !this.state[field]) {
          warning += warning ? `, ${REQUIRED_APPT_FIELDS[field]}` : `Please select a(n) ${REQUIRED_APPT_FIELDS[field]}`;
        }
      });
    }
    if (!warning &&
        dateTimeChanged &&
        autoComm &&
        !apptInPast) warning = AUTO_COMM_MESSAGE;
    return warning;
  }

  renderDeliveryDialog = (apptType) => {
    if (apptType === 'delivery') {
      return 'An installation appointment should be scheduled 3-5 days after the delivery';
    } else if (apptType === 'delivery_hold') {
      return 'An installation hold should be scheduled 3-5 days after the delivery hold';
    } else if (apptType === 'deliver_stack_cali_bamboo') {
      return 'An installation appointment should be scheduled at least 7 days after the Cali Bamboo is delivered and stacked';
    }
    return '';
  }

  renderApptTypeBtns = () => {
    const { apptType } = this.state;
    const btnArray = [];
    const isInstall = apptType === 'installation';
    const isHold = apptType === 'installation_hold' || apptType === 'delivery_hold';
    const isAssessmentHold = apptType === 'assessment_hold';
    const isBust = apptType === 'bust_day';
    if (isAssessmentHold) {
      btnArray.push(<ColoredButton
        className={styles.apptTypeBtn}
        label="Convert Appt. To Assessment"
        onClick={() => this.submitAppointment({}, 'assessment')}
        color="green"
      />);
    }
    if (isHold || isBust) {
      btnArray.push(<ColoredButton
        className={styles.apptTypeBtn}
        label="Convert Appt. To Installation"
        onClick={this.isCcs() ?
          () => this.submitInstallSuggestionAppt({}, 'installation') :
          () => this.submitAppointment({}, 'installation')}
        color="green"
      />);
    }
    if (isInstall || isBust) {
      btnArray.push(<ColoredButton
        className={styles.apptTypeBtn}
        label="Convert Appt. To Installation Hold"
        onClick={this.isCcs() ?
          () => this.submitInstallSuggestionAppt({}, 'installation_hold') :
          () => this.submitAppointment({}, 'installation_hold')}
        color="blue"
      />);
    }
    if (!this.isCcs() && (isInstall || isHold)) {
      btnArray.push(<ColoredButton
        className={styles.apptTypeBtn}
        label="Bust Appt."
        onClick={() => this.submitAppointment({}, 'bust_day')}
        color="red"
      />);
    }
    /* We may want to re-ad buttons to flip back and forth between install suggestions/calendar */
    // if (!this.isCcs() && this.isInstallApptType()) {
    //   btnArray.push(<ColoredButton
    //     className={styles.apptTypeBtn}
    //     label="Revert to Appt. Suggestions"
    //     onClick={() => this.resetState(false)}
    //     color="red"
    //   />);
    // }
    return (btnArray.length > 0 && <div className={styles.apptTypeBtnContainer}>
      {btnArray.map(b => b)}
    </div>);
  }

  renderAppointmentForm = () => {
    const { apptType, startDate, endDate, arrivalStart, arrivalEnd, note, confirmationDate,
      pickupDate, zone, schedulingReason, smartSchedulable } = this.state;
    const { errors, phase, isEdit } = this.props;
    const momentDate = moment(startDate, DISPLAY_DATE);
    const showSchedulingReason = (phase.type === 'Installation' && !apptType.includes('inspection'));
    const ssDisabled = this.isCcs() && smartSchedulable;
    return (<div>
      <div className={styles.ResourceDetails}>
        <ResourceCardElement size="small" wrap>
          <DatePicker
            label="Start Date"
            value={startDate}
            onChange={this.handleStartDateChange}
            className={styles.datepicker}
            placeholder="Select Date"
            required
            disabled={ssDisabled}
            error={errors.startDate}
          />
        </ResourceCardElement>
        <ResourceCardElement size="small" wrap>
          <DatePicker
            label="End Date"
            value={endDate}
            onChange={this.handleEndDateChange}
            className={styles.datepicker}
            placeholder="Select Date"
            disabled={ssDisabled}
            required
            error={errors.endDate}
          />
        </ResourceCardElement>
        <ResourceCardElement size="small" wrap>
          <TimeInput
            label={`Arrival Start Time (${zone}) *`}
            value={arrivalStart}
            onChange={this.handleArrivalStartChange}
            disabled={(!isEdit && ssDisabled)}
            errors={errors.arrivalStart}
          />
        </ResourceCardElement>
        <ResourceCardElement size="small" wrap>
          <TimeInput
            label={`Arrival End Time (${zone}) *`}
            value={arrivalEnd}
            onChange={this.handleArrivalEndChange}
            disabled={(!isEdit && ssDisabled)}
            errors={errors.arrivalEnd}
          />
        </ResourceCardElement>
      </div>
      <div className={styles.ResourceDetails}>
        {!['installation', 'repair'].includes(apptType) &&
          <ResourceCardElement size="small" wrap className={styles.confirmationDate}>
            <DatePicker
              label="Appt. Confirmation Date"
              placeholder="Select Date"
              value={confirmationDate}
              maxDate={momentDate.toDate()}
              className={styles.datepicker}
              onChange={this.handleConfirmationDateChange('confirmationDate')}
              error={errors.confirmationDate}
            />
          </ResourceCardElement>}
        <ResourceCardElement size="small" wrap className={styles.confirmationDate}>
          <DatePicker
            label="Pickup Date"
            value={pickupDate}
            maxDate={momentDate.toDate()}
            onChange={this.handlePickupDateChange}
            className={styles.datepicker}
            placeholder="Select Date"
            error={errors.pickupDate}
          />
        </ResourceCardElement>
        {showSchedulingReason && <ResourceCardElement size="small" wrap>
          <ReactSelect
            label="Scheduling Reason"
            placeholder={'Select Reason'}
            onChange={this.handleSchedulingReasonChange}
            options={SCHEDULING_REASONS}
            value={schedulingReason}
            error={errors.schedulingReason}
            required
          />
        </ResourceCardElement>}
      </div>
      <div className={styles.formPadding}>
        <SimpleInput
          label="Notes"
          text={note.includes('WARNING:') ? note.split('WARNING:')[0] : note}
          errors={errors.note}
          onChange={this.handleNoteChange}
        />
      </div>
    </div>);
  }

  render = () => {
    const { userName, role, employableId, position, relatedPhases, isEdit, errors,
            quickSchedule,
            phase, phase: { id: phaseId, zip_code, type, surface_type: { name },
                            store: { delivery_method }, spig_delivery, source,
                            estimator_id, installer_id } } = this.props;
    const { zone, scheduleStart, assignee_type, workroom, surface_type, estimator, startDate,
      endDate, selectedAssignee, showRescheduleModal, showDialog, showDeliveryDialog, crew,
      defaultCalStart, smartSchedulable, applyDeliveryValidation, ssBlockage,
      showInstallSuggestions, suggestionKey, selectedDeliverySuggestion, schedulingReason, apptType,
      deliveryStartDate = '', needDelivery, showAssessmentSuggestions } = this.state;
    const startMoment = moment(scheduleStart);
    const endMoment = moment(scheduleStart).add(7, 'days');
    const dates = moment.range(startMoment, endMoment).toArray('days', true);
    const pAppt = this.pendingAppointment();
    const scheduleFilters = { assignee_type, workroom, surface_type, estimator, crew };
    if (!showInstallSuggestions && this.isDeliveryAppt(apptType)) scheduleFilters.surface_type = [];
    const warningDisplay = this.renderWarning();
    const disableButtonIfWarning = warningDisplay.length && warningDisplay !== AUTO_COMM_MESSAGE;
    const closeInspectionModal = showInstallSuggestions ?
      () => this.props.navigate(urls.phaseAppointments(phase)) : this.toggleConfirmDialog;
    return (<section>
      {isEdit && this.renderApptTypeBtns()}
      {showInstallSuggestions ? (<Card className={styles.scheduleCard}>
        <InstallSuggestions
          position={position}
          zone={zone}
          date={startDate}
          phase={phase}
          suggestionKey={suggestionKey}
          selectedDeliverySuggestion={selectedDeliverySuggestion}
          deliveryStartDate={deliveryStartDate}
          schedulingReason={schedulingReason}
          relatedPhases={relatedPhases}
          suggestionDisableReason={this.findSuggestionDisableReason(phase, selectedAssignee)}
          onSelect={this.handleSuggestionSelected}
          handleSubmit={() => this.handleSubmit('installation')}
          handleAltSub={() => this.handleSubmit('installation_hold')}
          handleSchedulingReasonChange={this.handleSchedulingReasonChange}
          overrideToCal={() => this.resetState(true)}
          needDelivery={needDelivery}
          deliveryArgs={{
            surfaceType: name, deliveryMethod: delivery_method, spigDelivery: spig_delivery,
          }}
          errors={errors}
        />
      </Card>) : (<Fragment>
        {showAssessmentSuggestions ? (<Card className={styles.scheduleCard}>
          <AssessmentSuggestions
            isCcs={this.isCcs()}
            zone={zone}
            date={startDate}
            phaseId={phaseId}
            phaseType={type}
            suggestionKey={suggestionKey}
            schedulingReason={schedulingReason}
            onSelect={this.handleSuggestionSelected}
            handleSubmit={this.submitAssessmentSuggestionAppt}
            handleShowAssessmentSuggestions={this.handleShowAssessmentSuggestions}
            clearAssessmentSuggestion={this.clearAssessmentSuggestion}
            isAfternoon={IS_AFTERNOON}
            errors={errors}
          />
        </Card>) : (<Fragment>
          <Card className={styles.scheduleCard}>
            <Calendar
              title="Select Assignee & Date"
              date={scheduleStart}
              defaultCalStart={defaultCalStart.toDate()}
              dates={dates}
              filters={scheduleFilters}
              onFilterChange={this.handleFilterChange}
              navigatePast={this.lastSchedule}
              navigateFuture={this.nextSchedule}
              selectable
              selectedDayStart={moment(startDate, DISPLAY_DATE, true)}
              selectedDayEnd={moment(endDate, DISPLAY_DATE, true)}
              selectedAssignee={selectedAssignee}
              onSelect={this.handleScheduleSelect}
              pendingAppointment={pAppt}
              headerClassName={styles.scheduleHeader}
              filterClassName={styles.filters}
              filterTheme={FILTER_THEME}
              handleJumpDate={this.handleJumpDate}
              role={role}
              username={userName}
              onOpeningClick={this.handleOpeningClick}
              applySmartScheduling={smartSchedulable}
              handleDeliveryValidation={this.handleDeliveryValidation}
              relatedPhases={relatedPhases}
              setDelayedField={this.setDelayedField}
              isCcs={this.isCcs()}
              employableId={employableId}
              phaseZip={zip_code}
              phaseType={type}
              phaseSource={source}
              phaseEstimatorId={estimator_id}
              phaseInstallerId={installer_id}
              handleShowAssessmentSuggestions={this.handleShowAssessmentSuggestions}
            />
          </Card>
          <Card className={styles.contentArea}>
            <div className={styles.headerContainer}>
              <div className={styles.sectionTitle}>Schedule An Appointment</div>
              {needDelivery && <Switch
                name="Validate Delivery"
                label="Validate Delivery"
                onChange={this.handleDeliveryValidation}
                checked={applyDeliveryValidation}
              />}
            </div>
            {this.renderAppointmentForm()}
            <div className={styles.workerContainer}>
              <div className={styles.saveButtonContainer}>
                <ColoredButton
                  className={styles.mainSubmitButton}
                  label="Cancel"
                  onClick={this.handleCancel}
                  color="gray"
                />
                {quickSchedule && (<ColoredButton
                  className={styles.mainSubmitButton}
                  label={quickSchedule.label || 'Send Quick Schedule'}
                  onClick={() => this.handleSubmit(quickSchedule.forceKind || '')}
                  disabled={disableButtonIfWarning}
                  color="green"
                />)}
                {!quickSchedule && ((!isEdit && this.isInstallApptType()) ? (<Fragment>
                  <ColoredButton
                    className={styles.mainSubmitButton}
                    label="Save As Installation"
                    onClick={() => this.handleSubmit('installation')}
                    disabled={disableButtonIfWarning || apptType === 'installation_hold'}
                    color="green"
                  />
                  <ColoredButton
                    label="Save As Hold"
                    onClick={() => this.handleSubmit('installation_hold')}
                    disabled={disableButtonIfWarning}
                    color="blue"
                  />
                </Fragment>) : (<ColoredButton
                  className={styles.mainSubmitButton}
                  label="Save Appointment"
                  onClick={() => this.handleSubmit()}
                  disabled={disableButtonIfWarning}
                />))}
              </div>
              {warningDisplay && <div className={styles.fieldsWarning}>{warningDisplay}</div>}
            </div>
          </Card>
        </Fragment>)}
      </Fragment>)}
      <RescheduleAppointmentModal
        type={type}
        active={showRescheduleModal}
        onSubmit={showInstallSuggestions ?
          this.submitInstallSuggestionAppt : this.submitAppointment}
        onClose={this.handleRescheduleClose}
        ssBlockage={ssBlockage}
        errors={errors}
      />
      {showDialog && <ConfirmDialog
        theActions={['OK']}
        title="Schedule Crew Inspection"
        confirmation="The scheduled crew has less than 5 completed appointments."
        dismiss={closeInspectionModal}
        proceed={closeInspectionModal}
      />}
      {showDeliveryDialog && <ConfirmDialog
        theActions={['OK']}
        title={apptType === 'delivery_hold' ? 'Schedule Installation Hold' : 'Schedule Installation'}
        confirmation={this.renderDeliveryDialog(apptType)}
        dismiss={() => this.handleDeliveryApptSuccess(apptType)}
        proceed={() => this.handleDeliveryApptSuccess(apptType)}
      />}
    </section>);
  }
}

SchedulePhaseAppointment.defaultProps = {
  originalDate: null,
  originalStart: '',
  originalEnd: '',
  isEdit: false,
  errors: {},
};

SchedulePhaseAppointment.propTypes = {
  phase: PhaseType.isRequired,
  navigate: PropTypes.func.isRequired,
  requestPhaseItems: PropTypes.func,
  onSubmit: PropTypes.func,
  addValidationErrors: PropTypes.func.isRequired,
  requestRelatedPhases: PropTypes.func.isRequired,
  appointment: Appointment,
  errors: PropTypes.object,
  userName: PropTypes.string,
  role: PropTypes.string,
  employableId: PropTypes.number,
  employableType: PropTypes.string,
  position: PropTypes.string,
  originalDate: PropTypes.string,
  originalStart: PropTypes.string,
  originalEnd: PropTypes.string,
  isEdit: PropTypes.bool,
  relatedPhases: PropTypes.array,
  mvw: PropTypes.object,
  quickSchedule: PropTypes.shape({
    onSubmit: PropTypes.func.isRequired,
    label: PropTypes.string,
    forceKind: PropTypes.string,
  }),
};

const mapStateToProps = (state) => {
  const { phase: { details, related: { data } },
          user: { name, role, position, employable_id, employable_type,
                  manage_vendor_workrooms } } = state;
  return {
    phase: details,
    relatedPhases: data,
    userName: name,
    employableId: employable_id,
    employableType: employable_type,
    mvw: manage_vendor_workrooms,
    role,
    position,
  };
};

export default connect(
  mapStateToProps, { navigate, requestRelatedPhases, addValidationErrors },
)(SchedulePhaseAppointment);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/schedulePhaseAppointment.jsx